module.exports = __webpack_public_path__ + "img/LogoNO-full.sorthvid-2.5ebf5634.png";